
<body>

    <div [ngClass]="{
        'main-content': selectedPalette === 'Billcentrix',
        'main-content-modern': selectedPalette === 'Moderna',
        'main-content-violet': selectedPalette === 'Violeta'
      }">
    <app-header></app-header>
    <div class="main-image">
      <div class="text">
        <h1>{{ 'plansPreview.hero.title' | translate }}</h1>
        <p>{{ 'plansPreview.hero.subtitle' | translate }}</p>

      </div>
    </div>
    <div class="plans">
      <p>{{ 'plansPreview.plans.title' | translate }}</p>
      <app-plan-basic [selectedPalette]="selectedPalette"></app-plan-basic>
    </div>
    <div class="banner-content">
      <div class="text">
        <h1>{{ 'plansPreview.banner.title' | translate }}</h1>
        <p>{{ 'plansPreview.banner.description' | translate }}</p>
      </div>
      <div class="white-image"></div>
    </div>
    <div class="footer">
      <hr>
        <div class="mail">
          @if (selectedPalette === 'Billcentrix') {
            <img src="../../../assets/icons/mail.png" alt="icono de mail">
          }
          @if (selectedPalette === 'Moderna') {
            <img src="../../../assets/icons/mail-green.png" alt="icono de mail">
          }
          @if (selectedPalette === 'Violeta') {
            <img src="../../../assets/icons/mail-violet.png" alt="icono de mail">
          }
          <h2>Forma&#64;<strong>decontacto.com</strong></h2>
        </div>
      </div>
    </div>
    <!-- <div class="options-buttons">
    <button class="back-btn">Atrás</button>
    <button class="continue-btn">Seleccionar</button>
  </div> -->
</body>